<template>
  <path
    d="M12 2.00024C6.5 2.00024 2 6.50024 2 12.0002C2 17.5002 6.5 22.0002 12 22.0002C17.5 22.0002 22 17.5002 22 12.0002C22 6.50024 17.5 2.00024 12 2.00024ZM13 4.07024C16.61 4.52024 19.48 7.40024 19.93 11.0002H14C13.45 11.0002 13 10.5502 13 10.0002V4.07024ZM4 12.0002C4 7.94024 7.07 4.56024 11 4.07024V19.9402C7.07 19.4402 4 16.0602 4 12.0002ZM13 19.9302V14.0002C13 13.4502 13.45 13.0002 14 13.0002H19.93C19.48 16.6102 16.61 19.4802 13 19.9302Z"
  />
</template>
